'use client';
import React from 'react';
import { useRouter } from 'next/navigation';

import { Button, IconButton, Typography } from 'lighthouse';

import { goBackOrHome } from '@/utilities/goBackOrHome';

import { useSupportStore } from '@/stores/support/useSupportStore';

import RequestStepper from '../RequestStepper';
import { RequestWrapperProps } from './models';

import { ArrowRight, Call } from 'iconsax-react';

const RequestWrapper = ({ headerTitle, title, subTitle, children, hasTitleDivider = true, className, steps, currentStep }: RequestWrapperProps) => {
    const router = useRouter();
    const openSupport = useSupportStore((store) => store.openSupport);

    return (
        <section className={`bg-primary ${className ? className : ''}`}>
            <div className='sticky top-0 z-30 bg-primary'>
                <div className='flex justify-center px-4 py-3'>
                    <Typography variant='subtitle1' className='flex items-center text-white'>
                        <IconButton onClick={() => goBackOrHome(router)}>
                            <ArrowRight className='text-white' color='currentcolor' size='24' />
                        </IconButton>
                        {headerTitle ? headerTitle : ''}
                    </Typography>
                    <div className='mr-auto'>
                        <Button
                            variant='contained'
                            className='bg-white text-black'
                            startIcon={<Call size={16} color='currentcolor' />}
                            onClick={() => openSupport('request_header')}>
                            پشتیبانی
                        </Button>
                    </div>
                </div>
                {!!steps?.length && !!currentStep && <RequestStepper steps={steps} currentStep={currentStep} />}
            </div>
            <div data-funnel-content className='relative z-0 min-h-[calc(100dvh-66px)] rounded-t-lg bg-neutral-50 px-4 pb-36 pt-4'>
                {title && (
                    <div className={`pb-4 ${hasTitleDivider ? 'mb-4 border-x-0 border-t-0 border-solid border-b-primary' : ''}`}>
                        <Typography variant='subtitle2' display='block'>
                            {title}
                        </Typography>
                        {subTitle && <Typography className='mt-2 text-[10px] text-gray-500'>{subTitle}</Typography>}
                    </div>
                )}
                {children}
            </div>
        </section>
    );
};

export default RequestWrapper;
